<template>
    <div id="config-rattachment">
        <div class="config-header">
            <div class="back">
                <router-link to="/">
                    <font-awesome-icon icon="home" class="back-icon" />
                </router-link>
            </div>
        </div>

        <ModalRattachmentLoading v-if="loadingModalMessage" v-model="loadingModalMessage" />
        <ModalRattachmentMessage
            v-if="messageModalMessage"
            v-model="messageModalMessage"
            v-bind:header="headerModalMessage"
            v-bind:body="bodyModalMessage"
            v-bind:error="errorModalMessage"
            v-bind:footer="footerModalMessage"
            @dismiss="messageModalMessage = null"
        />

        <h2 v-if="$route.params.form === 'insert'" class="title">
            Création d'une session de rattachement
        </h2>
        <h2 v-if="$route.params.form === 'update'" class="title">
            Édition de la session de rattachement #{{ $route.params.id }}
        </h2>
        <h2 v-if="$route.params.form === 'duplicate'" class="title">
            Clonage de la session de rattachement #{{ $route.params.id }}
        </h2>
        <LoadingDots v-if="isLoading" />

        <!-- Formulaire -->
        <div v-if="!isLoading && rattachment">
            <!-- Général -->
            <div class="config-body">
                <div class="config-section">
                    <h3 class="section--title">Général</h3>

                    <div class="form-control">
                        <label>
                            Nom de la session <b>(obligatoire)</b>
                            <CustomInputUniqChecker
                                required
                                class="stretch"
                                v-model="rattachment.name"
                                :err-msg="`Une session nommée ${rattachment.name} existe déjà`"
                                url="/api/check/rattachment/name"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Est-ce une session de rattachement inverse (filaires sans données
                            métier) ?
                            <Select
                                class="stretch"
                                name="isinverse"
                                :options="trueFalseList"
                                :value="trueFalseList.find((e) => e.id === rattachment.isinverse)"
                                @input="rattachment.isinverse = $event.id"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control" v-if="rattachment.isinverse !== true">
                        <label>
                            La session de rattachement sera t-elle suivie par une session de
                            rattachement inverse ?
                            <Select
                                class="stretch"
                                name="isfollowedbyreverse"
                                :options="trueFalseList"
                                :value="
                                    trueFalseList.find(
                                        (e) => e.id === rattachment.isfollowedbyreverse,
                                    )
                                "
                                @input="rattachment.isfollowedbyreverse = $event.id"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <!-- Connexion PostgreSQL -->
            <div class="config-body">
                <div class="config-section">
                    <h3 class="section--title">Connexion PostgreSQL</h3>

                    <div class="form-control">
                        <label>
                            Nom d'hôte <b>(obligatoire)</b>
                            <CustomInput required class="stretch" v-model="rattachment.host" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Port <b>(obligatoire)</b>
                            <CustomInput
                                type="integer"
                                required
                                class="stretch"
                                v-model="rattachment.port"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Nom de la base de données <b>(obligatoire)</b>
                            <CustomInput required class="stretch" v-model="rattachment.db" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Utilisateur
                            <CustomInput class="stretch" v-model="rattachment.user" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Mot de passe de l'utilisateur
                            <CustomInput
                                type="password"
                                class="stretch"
                                v-model="rattachment.pass"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <!-- Paramètres du rattachement -->
            <div class="config-body">
                <div class="config-section">
                    <h3 class="section--title">Paramètres du rattachement</h3>

                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Table du filaire à jour [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Table du filaire à jour à rattacher [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.tablefil"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control" v-if="rattachment.isinverse === true">
                        <label>
                            Clause WHERE à appliquer sur les filaires à rattacher. Attention,
                            veuillez préfixer le nom des champs par "l.", par exemple : l.highway =
                            'motorway'
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.tablefil_where"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Table attributaire à rattacher [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Table attributaire des données métier [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.tableattr"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Table géométrique à rattacher [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Table géométrique des données métier [schema.table]
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.tablegeom"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control" v-if="rattachment.isinverse !== true">
                        <label>
                            Nom du schéma pour les tables temporaires <b>(obligatoire)</b> (le
                            schéma <b>doit</b> exister)
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.schema_temp"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Nom du champ identifiant les données à rattacher
                                <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Nom du champ identifiant les données métier
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.fid"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Nom du champ contenant la géométrie à rattacher
                                <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Nom du champ contenant la géométrie des données métier
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.fgeom"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Nom des champs communs filaire/table métier géométrique [séparés
                                par une virgule] <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Nom des champs communs filaire/table géométrique métier [séparés
                                par une virgule] <b>(obligatoire)</b></template
                            >
                            <CustomInput
                                required
                                class="stretch"
                                v-model="rattachment.tablefil_attr"
                            />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            <template v-if="rattachment.isinverse !== true"
                                >Nom des champs à visualiser dans l'interface [séparés par une
                                virgule] <b>(obligatoire)</b></template
                            >
                            <template v-if="rattachment.isinverse === true"
                                >Nom des champs métier [séparés par une virgule]
                                <b>(obligatoire)</b></template
                            >
                            <CustomInput required class="stretch" v-model="rattachment.flist" />
                        </label>
                    </div>
                    <div class="form-control">
                        <label>
                            Code EPSG du système de coordonnées des données géométriques
                            <b>(obligatoire)</b>
                            <CustomInput
                                type="integer"
                                required
                                class="stretch"
                                v-model="rattachment.epsg"
                                :disabled="rattachment.id ? true : false"
                            />
                        </label>
                    </div>
                    <div class="form-control" v-if="rattachment.isinverse !== true">
                        <label>
                            Tolérance du rattachement automatique [en mètres] <b>(obligatoire)</b>
                            <CustomInput
                                type="decimal"
                                required
                                class="stretch"
                                v-model="rattachment.tolerance"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <!-- Propriétés de la session -->
            <div class="config-body" v-if="!!rattachment.id">
                <div class="config-section">
                    <h3 class="section--title">Propriétés de la session</h3>

                    <div class="form-control" v-show="!!rattachment.id">
                        <label>
                            Date d'ouverture de la session
                            <CustomInput disabled class="stretch" v-model="rattachment.startdate" />
                        </label>
                    </div>
                    <div
                        class="form-control"
                        v-show="rattachment.isinverse !== true && !!rattachment.id"
                    >
                        <label>
                            Nom de la table temporaire des données attributaires
                            <CustomInput
                                disabled
                                class="stretch"
                                v-model="rattachment.tableattr_temp"
                            />
                        </label>
                    </div>
                    <div
                        class="form-control"
                        v-show="rattachment.isinverse !== true && !!rattachment.id"
                    >
                        <label>
                            Nom de la table temporaire des données géométriques
                            <CustomInput
                                disabled
                                class="stretch"
                                v-model="rattachment.tablegeom_temp"
                            />
                        </label>
                    </div>
                    <div class="form-control" v-show="!!rattachment.id">
                        <label>
                            Date de clôture de la session
                            <CustomInput disabled class="stretch" v-model="rattachment.enddate" />
                        </label>
                    </div>
                </div>
            </div>

            <div class="config-section mt-5">
                <div class="form-control form-inline">
                    <Button class="stretch" @click="exitForm">Annuler</Button>
                    <Button class="default stretch" @click="saveRattachment">Enregistrer</Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingDots from './../../components/LoadingDots';
import Button from './../../components/Button';
import CustomInput from './../../components/Input';
import CustomInputUniqChecker from './../../components/InputUniqChecker';
import ModalRattachmentLoading from './../../components/config/ModalRattachmentLoading';
import ModalRattachmentMessage from './../../components/config/ModalRattachmentMessage';
import Select from './../../components/Select';

export default {
    data() {
        return {
            isLoading: true,
            rattachment: null,
            loadingModalMessage: null,
            messageModalMessage: null,
            trueFalseList: [{ id: true, text: 'Oui' }, { id: false, text: 'Non' }],
        };
    },
    computed: {},
    mounted() {
        if (this.$route.params && this.$route.params.form === 'update' && this.$route.params.id) {
            this.getRattachment(this.$route.params.id).then((rattachment) => {
                this.rattachment = rattachment;
            });
        } else if (this.$route.params && this.$route.params.form === 'insert') {
            this.rattachment = {
                id: null,
                name: '',
                host: null,
                port: 5432,
                db: null,
                user: null,
                pass: null,
                tablefil: 'osm.filairefromlbt',
                tablefil_where: '',
                tablefil_attr:
                    'gid,osm_id,tag_id,length,length_m,name,source,target,source_osm,target_osm,cost,reverse_cost,cost_s,reverse_cost_s,rule,one_way,oneway,x1,y1,x2,y2,maxspeed_forward,maxspeed_backward,priority,access,alt_name,area,barrier,bicycle,bridge,construction,covered,cycleway,cycleway_left,cycleway_right,foot,highway,junction,lanes,lanes_backward,lanes_forward,lanes_psv,lanes_psv_backward,lanes_psv_forward,layer,maxheight,parking_lane_both,parking_lane_left,parking_lane_right,psv,railway,ref,service,sidewalk,status,surface,tracktype,traffic_calming,tunnel,turn_lanes,wheelchair,zone_maxspeed,old_name,official_name,osm_user,osm_version,zone_agg,code_insee,nom_commune,ref_mmm,gestionnaire,exploitant,hierarchie,bus,rgc,te,code_voie,the_geom',
                tableattr: null,
                tablegeom: null,
                schema_temp: null,
                fid: 'gid',
                fgeom: 'geom',
                flist: null,
                tolerance: 0.01,
                epsg: 2154,
                isinverse: false,
                isfollowedbyreverse: true,
            };
        } else if (
            this.$route.params &&
            this.$route.params.form === 'duplicate' &&
            this.$route.params.id
        ) {
            this.getRattachment(this.$route.params.id).then((rattachment) => {
                this.rattachment = rattachment;
                this.rattachment.id = null;
                this.rattachment.name = '';
                this.rattachment.isclosed = false;
            });
        }
        this.isLoading = false;
    },
    methods: {
        /**
         * Charge depuis l'API les infos de la session de rattachement par son id
         */
        getRattachment(id) {
            return new Promise((resolve, reject) => {
                this.$http.get(`/api/rattachment/${id}`).then(
                    (response) => {
                        this.isLoading = false;
                        if (response.body && response.body.id) {
                            resolve(response.body);
                        } else {
                            reject();
                        }
                    },
                    (response) => {
                        // error callback
                        this.isLoading = false;
                        console.error(response);
                        reject();
                    },
                );
            });
        },
        /**
         * Enregistre les modifications
         */
        saveRattachment() {
            if (this.$route.params && this.$route.params.form === 'update') {
                this.updateRattachment();
            }

            if (this.$route.params && this.$route.params.form === 'insert') {
                this.insertRattachment();
            }

            if (this.$route.params && this.$route.params.form === 'duplicate') {
                this.insertRattachment();
            }
        },
        /**
         * Met à jour une session
         */
        updateRattachment() {
            if (
                this.rattachment.id &&
                this.rattachment.name &&
                this.rattachment.host &&
                this.rattachment.port &&
                this.rattachment.db &&
                this.rattachment.flist &&
                this.rattachment.tolerance
            ) {
                this.$http
                    .put(`/api/rattachment/${this.rattachment.id}`, this.rattachment)
                    .then((response) => {
                        if (response.body && response.body.id) {
                            this.exitForm();
                        } else {
                            this.messageModalMessage =
                                'Erreur lors de la mise à jour\nde la session de rattachement';
                        }
                    })
                    .catch((err) => {
                        this.loadingModalMessage = null;
                        this.messageModalMessage = 'Erreur';
                        this.headerModalMessage =
                            'Erreur lors de la mise à jour\nde la session de rattachement';
                        this.bodyModalMessage = null;
                        this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                            err.body.error.name
                        }\nCode : ${err.body.error.original.code}\nRoutine : ${
                            err.body.error.original.routine
                        }`;
                        this.footerModalMessage = null;
                    })
                    .finally(() => (this.isLoading = false));
            } else {
                console.error('rattachment not valid');
                this.loadingModalMessage = null;
                this.messageModalMessage = 'Erreur';
                this.headerModalMessage =
                    'Erreur lors de la mise à jour\nde la session de rattachement';
                this.bodyModalMessage = null;
                this.errorModalMessage = 'Paramètres manquants';
                this.footerModalMessage = null;
            }
        },
        /**
         * Ajout d'une session (ou via clonage)
         */
        insertRattachment() {
            if (
                !this.rattachment.id &&
                this.rattachment.name &&
                this.rattachment.host &&
                this.rattachment.port &&
                this.rattachment.db &&
                this.rattachment.tablefil &&
                this.rattachment.tablefil_attr &&
                this.rattachment.tableattr &&
                this.rattachment.tablegeom &&
                this.rattachment.fid &&
                this.rattachment.fgeom &&
                this.rattachment.epsg
            ) {
                this.loadingModalMessage = 'Initialisation de la session de rattachement en cours…';
                this.$http
                    .post('/api/rattachment', this.rattachment)
                    .then(() => {
                        this.loadingModalMessage = null;
                        this.exitForm();
                    })
                    .catch((err) => {
                        this.loadingModalMessage = null;
                        this.messageModalMessage = 'Erreur';
                        this.headerModalMessage =
                            'Erreur lors de la création\nde la session de rattachement';
                        this.bodyModalMessage = null;
                        this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                            err.body.error.name
                        }\nCode : ${err.body.error.original.code}\nRoutine : ${
                            err.body.error.original.routine
                        }`;
                        this.footerModalMessage = null;
                    })
                    .finally(() => (this.isLoading = false));
            } else {
                console.error('rattachment not valid');
                this.loadingModalMessage = null;
                this.messageModalMessage = 'Erreur';
                this.headerModalMessage =
                    'Erreur lors de la création\nde la session de rattachement';
                this.bodyModalMessage = null;
                this.errorModalMessage = 'Paramètres manquants';
                this.footerModalMessage = null;
            }
        },
        /**
         * Annule l'édition/insertion
         */
        exitForm() {
            this.$router.push({ name: 'rattachmentconfig' });
        },
    },
    components: {
        LoadingDots,
        Button,
        CustomInput,
        CustomInputUniqChecker,
        ModalRattachmentLoading,
        ModalRattachmentMessage,
        Select,
    },
};
</script>

<style lang="scss">
#config-rattachment {
    .form-control {
        input[type='text']:disabled {
            background: #ddd;
        }
    }
}
</style>
